<script>
	import { createEventDispatcher, onDestroy, onMount } from "svelte";
	import { fade, fly } from "svelte/transition";
	import {
		imageLightbox,
		imageLightboxCaptions,
		imageLightboxIndex,
	} from "../../store/store";
	import Slide from "./Slide.svelte";
	import Thumbnail from "./Thumbnail.svelte";
	import Caption from "./Caption.svelte";

	const dispatch = createEventDispatcher();

	/* IMAGE TO SHOW */
	export let imageShowingIndex = 0;
	export let boxes = [];
	export let origShape = []; // [Height, Width]
	export let changeIdx = () => {};
	export let videoFrameThumbnails = false;
	$: image = $imageLightbox[imageShowingIndex];

	const nextSlide = () => {
		if (imageShowingIndex === $imageLightbox.length - 1) {
			imageShowingIndex = 0;
		} else {
			imageShowingIndex += 1;
		}
		changeIdx(imageShowingIndex);
	};

	const prevSlide = () => {
		if (imageShowingIndex === 0) {
			imageShowingIndex = $imageLightbox.length - 1;
		} else {
			imageShowingIndex -= 1;
		}
		changeIdx(imageShowingIndex);
	};

	const goToSlide = (slideID) => {
		imageShowingIndex = Number(slideID);
		changeIdx(imageShowingIndex);
	};

	onMount(() => {
		const handleKeydown = (event) => {
			if (event.key === "ArrowRight") {
				nextSlide();
			} else if (event.key === "ArrowLeft") {
				prevSlide();
			} else if (event.key === "Escape") {
				dispatch("click");
			}
		};

		window.addEventListener("keydown", handleKeydown);

		return () => {
			window.removeEventListener("keydown", handleKeydown);
		};
	});

	onDestroy(() => {
		imageLightbox.set([]);
		imageLightboxCaptions.set([]);
		imageLightboxIndex.set(0);
	});
</script>

<section class="lightbox" in:fly={{ x: -300 }} out:fade>
	<main>
		<!-- image gallery -->
		<button type="button" class="close cursor" aria-label="Close" on:click
			>X</button
		>

		<!-- Image text -->
		<Caption
			caption={$imageLightboxCaptions[imageShowingIndex] ?? []}
			on:prevClick={prevSlide}
			on:nextClick={nextSlide}
		>
			<div class="container">
				<Slide
					image={$imageLightbox[imageShowingIndex]}
					slideNo={imageShowingIndex + 1}
					totalSlides={$imageLightbox.length}
				/>
				{#if boxes.length > 0 && origShape.length > 0}
					{#each boxes as box}
						<span
							class="bounding-box"
							style="
						left: {(box[0] / origShape[1]) * 100}%;
						top: {(box[2] / origShape[0]) * 100}%;
						width: {((box[1] - box[0]) / origShape[1]) * 100}%;
						height: {((box[3] - box[2]) / origShape[0]) * 100}%;"
						/>
					{/each}
				{/if}
			</div>
		</Caption>

		<!-- Thumbnail images -->
		<div class="thumbnails-row">
			{#each $imageLightbox as imgurl, id}
				<Thumbnail
					thumbImg={imgurl}
					{id}
					videoFrame={videoFrameThumbnails}
					selected={Number(imageShowingIndex) === id}
					on:click={() => goToSlide(id)}
				/>
			{/each}
		</div>
	</main>
</section>

<style>
	@import url("https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@500&display=swap");

	* {
		box-sizing: border-box;
		font-family: "Josefin Sans", sans-serif;
	}

	.lightbox {
		position: fixed;
		z-index: 9999;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow: auto;
		background: rgba(0, 0, 0, 0.9);
		display: flex;
		justify-content: center;
	}

	main {
		width: 50vw;
		display: flex;
		flex-direction: column;
	}

	/* Position the image container (needed to position the left and right arrows) */
	.container {
		position: relative;
	}

	.thumbnails-row {
		width: 100%;
		display: flex;
		align-self: flex-end;
		justify-content: center;
		flex-wrap: wrap;
	}

	/* The Close Button */
	.close {
		background: none;
		border: none;
		padding: 0;
		color: #ddd;
		position: absolute;
		top: 1%;
		right: 3%;
		font-size: 1.5rem;
		font-weight: 200;
	}

	.close:hover,
	.close:focus {
		color: #999;
		text-decoration: none;
		cursor: pointer;
	}
</style>
